import { useQuery } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { DeviceInventoryListResponse } from './device-inventory.types';

/** Site-local auto-discovered inventory for every controller (R-097 P3). One round
 *  trip for the whole site; the UI groups the flat channels by mac_address. */
export function useDeviceInventory() {
  return useQuery({
    queryKey: ['device-inventory-local'],
    queryFn: () => api.get<DeviceInventoryListResponse>('/v1/device-inventory'),
    staleTime: 30_000,
  });
}
